import type {
  CollectedNames,
  EditProfileIdentityError,
  IdentityEditScope,
  ProfileIdentityDraft,
  ReferenceNames,
  SavedIdentity,
  SaveStatus,
} from '../domain/profile-identity-draft.model';

/**
 * Redux state for the admin identity-correction dialog: the editable draft, the
 * collected names it is diffed against, per-field validation errors, the save
 * lifecycle, the last business error, and the identity returned by a successful
 * save (which the host merges into the row it is showing). Every field is
 * serialisable.
 *
 * `profileId` lives here rather than being passed to `submitRequested` so the
 * saga has everything it needs from `select` alone.
 */
export interface EditProfileIdentityState {
  profileId: string | null;
  scope: IdentityEditScope;
  draft: ProfileIdentityDraft;
  collected: CollectedNames;
  reference: ReferenceNames;
  validationErrors: Record<string, string>;
  saveStatus: SaveStatus;
  error: EditProfileIdentityError | null;
  savedIdentity: SavedIdentity | null;
}

export const emptyDraft: ProfileIdentityDraft = { firstName: '', lastName: '', linkedinUrl: '' };

export const emptyCollected: CollectedNames = { firstName: '', lastName: '', editedAt: null };

export const initialState: EditProfileIdentityState = {
  profileId: null,
  scope: 'global',
  draft: emptyDraft,
  collected: emptyCollected,
  reference: { firstName: '', lastName: '' },
  validationErrors: {},
  saveStatus: 'idle',
  error: null,
  savedIdentity: null,
};
